import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { orderApi } from "../features/orders/orderApi";
import createOrderDetailsReducer from "../features/orders/createOrderDetailsSlice";

const persistConfig = {
  key: "car-service-app",
  storage,
//   whitelist: ['createOrderDetails'],
};

const reduxPersistActions = [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER];

const persistedReducer = persistReducer(
  persistConfig,
  createOrderDetailsReducer
);

const store = configureStore({
  reducer: {
    orderApi: orderApi.reducer,
    createOrderDetails: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [...reduxPersistActions],
      },
    })
    .concat(orderApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const persistor = persistStore(store);
export default store;
